import 'babel-polyfill';

import React from 'react';
import {connect} from 'react-redux';

import mui from 'material-ui';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import RhinoTheme from '../../themes/rhino';
import injectTapEventPlugin from 'react-tap-event-plugin';
injectTapEventPlugin();

import * as authActionCreators from '../../actions/auth';

class App extends React.Component {

	constructor() {
		super();
	}

	static childContextTypes = {
		muiTheme: React.PropTypes.object
	};

	static muiTheme = getMuiTheme(RhinoTheme);

	render() {
		return <MuiThemeProvider muiTheme={this.muiTheme}>{this.props.children}</MuiThemeProvider>;
	}
}
export default App;

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}

export const AppContainer = connect(
  mapStateToProps,
  authActionCreators
)(App);


// WEBPACK FOOTER //
// ./src/components/common/App.jsx